export default "__VITE_ASSET__DFtV9fbs__"